import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { SectionWrap } from '../../Components';
import LoadingPage from '../LoadingPage/LoadingPage';
import './TagPostsPage.css';
import { formatISO9075 } from 'date-fns';

function TagPostsPage() {
  // const apiUrl = 'http://localhost/server/testServer';
  const apiUrl = 'https://www.albarede.com/server';
  const { tag } = useParams(); // لاستخراج الوسم من الـ URL
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!tag) {
      setLoading(false);
      setError("لا يوجد وسم محدد.");
      return;
    }

    setLoading(true);
    setError(null);

    // فك ترميز الوسم قبل إرساله للخادم
    const decodedTag = decodeURIComponent(tag); 

    fetch(`${apiUrl}/post.php?tag=${decodedTag}`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        if (data.error) {
            throw new Error(data.error);
        }
        setPosts(data);
      })
      .catch(err => {
        console.error('Error fetching posts by tag:', err);
        setError("فشل في جلب المقالات. يرجى المحاولة لاحقاً.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [tag]);

  if (loading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <SectionWrap>
        <div className="tagPostsError">
          <h2>خطأ:</h2>
          <p>{error}</p>
        </div>
      </SectionWrap>
    );
  }

  return (
    <div className="tagPostsPage">
      <SectionWrap>
        <h1>المقالات المتعلقة بالوسم: {decodeURIComponent(tag)}</h1>
        {posts.length > 0 ? (
          <div className="postsGrid">
            {posts.map(post => (
              <div key={post.id} className="tagPostCard">
                <Link to={`/post/${post.id}`}>
                  {post.files && (
                    <img src={`${apiUrl}/${post.files}`} alt={post.title} />
                  )}
                  <h2>{post.title}</h2>
                </Link>
                <p className="summary">{post.summary}</p>
                <div className="meta">
                    <span>بقلم: {post.author}</span>
                    <span>تاريخ النشر: {formatISO9075(new Date(post.createAt))}</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p>لا توجد مقالات بهذا الوسم حالياً.</p>
        )}
      </SectionWrap>
    </div>
  );
}

export default TagPostsPage;